import _ from './tri-spinner.module.scss'
import React from 'react'
import {$$$, $} from '../shared/class-name'

const SQRT3 = Math.sqrt(3)

export const TriSpinner = ({size = 32, color = 'darkGray', block, visible, className, elevated, style, fill}) => {
    const cx = size / 2
    const cy = size / 2
    const d  = size * 0.25
    const r  = size * 0.1

    const v = [
        [cx - d * SQRT3 / 2,   cy - d / 2  ],
        [cx + d * SQRT3 / 2,   cy - d / 2  ],
        [cx,                    cy + d     ],
    ]

    const motionPath = i => {
        const from = v[i]
        const next = v[(i + 1) % v.length]
        const last = v[(i + 2) % v.length]

        return `M 0 0 L ${next[0] - from[0]} ${next[1] - from[1]} L ${last[0] - from[0]} ${last[1] - from[1]} Z`
    }
    const dur = 1.67

    return (
        <svg
            className={$$$(
                _.triSpinner,
                $(_[color], color),
                $(_.block, !!block),
                $(_.hidden, visible !== undefined && !visible),
                $(_.elevated, elevated),
                $(className),
                $(_.fill, fill),
            )}
            width={size}
            height={size}
            style={{
                ...style,
                marginTop: parseInt(block) ? `${block}px` : null,
                marginBottom: parseInt(block) ? `${block}px` : null,
            }}
            viewBox={`0 0 ${size} ${size}`}
        >
            {[0, 1, 2].map(i => (
                <circle key={i} cx={v[i][0]} cy={v[i][1]} r={r} className={_.dot} opacity={1 - i * 0.2}>
                    <animateMotion
                        dur={`${dur}s`}
                        repeatCount="indefinite"
                        path={motionPath(i)}
                        calcMode="spline"
                        keyPoints="0; 0.333; 0.667; 1"
                        keyTimes="0; 0.333; 0.667; 1"
                        keySplines="0 0 0.2 1; 0 0 0.2 1; 0 0 0.2 1"
                    />
                </circle>
            ))}
        </svg>
    )
}
